import {
    takeEvery, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/AdminSettingCustom';
import { waitAuthorizedCheck } from './Auth';

function* getSettingCustomColor(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/settings/${action.payload.eventShortName}/colors/?site=${action.payload.site}&language=${action.payload.language}`
        : `/api/v1/settings/${action.payload.eventShortName}/colors/?site=${action.payload.site}`;
    try {
        const response = yield call(API.get, {
            endpoint,
            body: {},
        });
        yield put(Actions.getSettingCustomColorReceived(response));
    } catch (error) {
        yield put(Actions.getSettingCustomColorReceiveFailure(yield error));
    }
}

function* updateSettingCustomColor(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/settings/${action.payload.eventShortName}/colors/`;
        const response = yield call(API.put, {
            endpoint,
            body: action.payload.data,
            token: credential.data.token,
        });
        yield put(Actions.updateSettingCustomColorReceived(response));
    } catch (error) {
        yield put(Actions.updateSettingCustomColorReceiveFailure(yield error));
    }
}

function* getSettingCustomText(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/settings/${action.payload.eventShortName}/texts/?site=${action.payload.site}&text_type=${action.payload.text_type}&language=${action.payload.language}`
        : `/api/v1/settings/${action.payload.eventShortName}/texts/?site=${action.payload.site}&text_type=${action.payload.text_type}`;
    try {
        const response = yield call(API.get, {
            endpoint,
            body: {},
        });
        yield put(Actions.getSettingCustomTextReceived(response));
    } catch (error) {
        yield put(Actions.getSettingCustomTextReceiveFailure(yield error));
    }
}

function* updateSettingCustomText(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/settings/${action.payload.eventShortName}/texts/`;
        const response = yield call(API.put, {
            endpoint,
            body: action.payload.data,
            token: credential.data.token,
        });
        yield put(Actions.updateSettingCustomTextReceived(response));
    } catch (error) {
        yield put(Actions.updateSettingCustomTextReceiveFailure(yield error));
    }
}

function* getSettingCustomComment(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/settings/${action.payload.eventShortName}/comment/?language=${action.payload?.language}`
        : `/api/v1/settings/${action.payload.eventShortName}/comment/`;
    try {
        const response = yield call(API.get, {
            endpoint,
            body: {},
        });
        yield put(Actions.getSettingCustomCommentReceived(response));
    } catch (error) {
        yield put(Actions.getSettingCustomCommentReceiveFailure(yield error));
    }
}

function* updateSettingCustomComment(action) {
    try {
        const credentail = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/settings/${action.payload.eventShortName}/comment/`;
        const response = yield call(API.put, {
            endpoint,
            body: action.payload.data,
            token: credentail.data.token,
        });
        yield put(Actions.updateSettingCustomCommentReceived(response));
    } catch (error) {
        yield put(Actions.getSettingCustomCommentReceiveFailure(yield error));
    }
}


function* getSettingCustomTimerctrl(action) {
    const endpoint = `/api/v1/settings/${action.payload.eventShortName}/timerctrl/`;
    try {
        const response = yield call(API.get, {
            endpoint,
            body: {},
        });
        yield put(Actions.getSettingCustomTimerctrlReceived(response));
    } catch (error) {
        yield put(Actions.getSettingCustomTimerctrlReceiveFailure(yield error));
    }
}

function* updateSettingCustomTimerctrl(action) {
    try {
        const credentail = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/settings/${action.payload.eventShortName}/timerctrl/`;
        const response = yield call(API.put, {
            endpoint,
            body: action.payload.data,
            token: credentail.data.token,
        });
        yield put(Actions.updateSettingCustomTimerctrlReceived(response));
    } catch (error) {
        yield put(Actions.getSettingCustomTimerctrlReceiveFailure(yield error));
    }
}


export default function* adminSettingCustom() {
    yield all([
        takeEvery('GET_SETTING_CUSTOM_COLOR_REQUEST'       , getSettingCustomColor),
        takeEvery('UPDATE_SETTING_CUSTOM_COLOR_REQUEST'    , updateSettingCustomColor),
        takeEvery('GET_SETTING_CUSTOM_TEXT_REQUEST'        , getSettingCustomText),
        takeEvery('UPDATE_SETTING_CUSTOM_TEXT_REQUEST'     , updateSettingCustomText),
        takeEvery('GET_SETTING_CUSTOM_COMMENT_REQUEST'     , getSettingCustomComment),
        takeEvery('UPDATE_SETTING_CUSTOM_COMMENT_REQUEST'  , updateSettingCustomComment),
        
        takeEvery('GET_SETTING_CUSTOM_TIMERCTRL_REQUEST'   , getSettingCustomTimerctrl   ),
        takeEvery('UPDATE_SETTING_CUSTOM_TIMERCTRL_REQUEST', updateSettingCustomTimerctrl),
        
    ]);
}
